module.exports = __webpack_public_path__ + "img/FLANDERS.b77bdb70.jpg";